import { styled as muiStyled } from "@mui/system";
import styled from "styled-components";

export const CartPageWrapper = muiStyled("div")({
  margin: "90px auto 0",
  textAlign: "center",
  width: "80%",

  ".grid_item": {},
});

export const AppCommonButton = styled.button`
  background: ${({ backgroundColor }) => backgroundColor || "black"};
  color: ${({ color }) => color || "white"};
  padding: ${({ padding }) => padding || "18px 20px"};
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  min-width: 160px;
  margin-top: ${({ marginTop }) => marginTop || 50}px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid black;

  &:hover {
    background: ${({ hoverBackgroundColor }) =>
      hoverBackgroundColor || "white"};
    color: ${({ hoverColor }) => hoverColor || "black"};
  }

  &:hover span {
    color: ${({ hoverColor }) => hoverColor || "black"};
  }

  &:hover img {
    filter: invert(1);
  }

  ${({ extraStyles }) =>
    extraStyles &&
    Object.entries(extraStyles).map(
      ([property, value]) => `${property}: ${value};`
    )}
`;
